module.exports = __webpack_public_path__ + "static/media/arman-feili.47aaae68.jpg";